// src/pages/gestion/Inicio.js

import React, { useState, useRef } from 'react'; // Añadir useEffect si es necesario
import {
  Grid,
  Box,
  Typography,
  Button,
  Modal,
  TextField,
  MenuItem,
  CircularProgress,
  Snackbar,
  Alert,
  Chip,
  LinearProgress, 
} from '@mui/material';
import { Add as AddIcon, PhotoCamera } from '@mui/icons-material';
import CompetitionCard from '../../components/gestion/CompetitionCard';
// Quitar importación de formatCurrency si NumericFormat lo maneja
// import formatCurrency from '../../utils/formatCurrency';
import { useCompetencia } from '../../context/CompetenciaContext';
import { useAuth } from '../../context/AuthContext'; // <-- IMPORTAR useAuth
import { NumericFormat } from 'react-number-format';
import { v4 as uuidv4 } from 'uuid';

// Importar funciones de Firebase Storage
import { storage } from '../../firebase'; // Importar storage inicializado
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import optimizeAndConvertToWebP from '../../utils/optimizeAndConvertToWebP';

// Componente para formatear moneda (sin cambios)
const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      thousandSeparator=","
      decimalSeparator="."
      valueIsNumericString // Importante para que funcione con value string
      prefix="$"
      decimalScale={2} // Permitir decimales
      fixedDecimalScale // Siempre mostrar decimales
      allowNegative={false}
      onValueChange={(values) => {
        // Asegúrate de llamar a onChange con el nombre del campo si es necesario
        // o directamente con el valor numérico correcto.
        // Aquí lo pasamos como string, que es lo que espera el TextField
        onChange({ target: { name: props.name, value: values.value } });
      }}
      value={props.value} // Asegúrate de pasar el valor
    />
  );
});


const GestionInicio = () => {
  const { competencias, addCompetencia, loading: loadingCompetencias } = useCompetencia(); // Renombrar loading
  const { user } = useAuth(); // <-- OBTENER EL USUARIO ACTUAL
  const [loadingCreate, setLoadingCreate] = useState(false); // Loading específico para la creación
  const [openModal, setOpenModal] = useState(false);
  const [newCompetencia, setNewCompetencia] = useState({
    nombre: '',
    fechaInicioCompetencia: '',
    fechaFinCompetencia: '',
    tipoCompetencia: '',
    estado: 'pendiente',
    precioInscripciones: '0', // Guardar como string numérico para NumericFormat
    imagen: null,
    imagenPreview: null, // Para mostrar la imagen seleccionada
    // Añadir otros campos que necesites del defaultCompetenciaFirestoreFields si son editables aquí
    lugar: '',
    // ... otros campos ...
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [uploadProgress, setUploadProgress] = useState(0); // Estado para progreso de subida
  const [isUploading, setIsUploading] = useState(false); // Estado para indicar subida activa

  const fileInputRef = useRef(null); // Referencia para limpiar input file

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

// Recibe el archivo optimizado (que es WebP)
const uploadImageAndGetURL = async (optimizedWebpFile, competenciaId) => {
  if (!optimizedWebpFile) return null;

  // *** Crear referencia con extensión .webp ***
  // Quita la extensión original (si la tuviera) y asegura .webp
  //const baseName = optimizedWebpFile.name.substring(0, optimizedWebpFile.name.lastIndexOf('.')) || optimizedWebpFile.name;
  const uniqueFileName = `portada_${Date.now()}.webp`; // Forzar extensión .webp
  const storageRef = ref(storage, `competencias/${competenciaId}/${uniqueFileName}`);

  console.log(`[Storage] Subiendo WebP a: ${storageRef.fullPath}`);
  setIsUploading(true);
  setUploadProgress(0);

  return new Promise((resolve, reject) => {
    // Pasar el archivo WebP optimizado
    const uploadTask = uploadBytesResumable(storageRef, optimizedWebpFile);

    uploadTask.on('state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('[Storage] Upload is ' + progress + '% done');
        setUploadProgress(progress);
      },
      (error) => {
        // ... (manejo de errores igual que antes) ...
         console.error("[Storage] Error en subida WebP:", error);
         setIsUploading(false);
         setUploadProgress(0);
         let message = 'Error al subir imagen WebP.';
         // ... (switch error.code) ...
         reject(new Error(message));
      },
      async () => {
        // ... (obtener URL igual que antes) ...
        console.log('[Storage] Subida WebP completada. Ref:', uploadTask.snapshot.ref.fullPath);
         try {
           console.log('[Storage] Intentando obtener URL de descarga WebP...');
           const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
           console.log('[Storage] URL WebP obtenida:', downloadURL);
           setIsUploading(false);
           resolve(downloadURL);
         } catch (getUrlError) {
            console.error("[Storage] Error específico obteniendo URL WebP:", getUrlError);
            // ... (loguear código y mensaje) ...
            setIsUploading(false);
            reject(new Error('Error obteniendo URL de imagen WebP tras subida.'));
         }
      }
    );
  });
};
// --- FIN NUEVA FUNCIÓN ---

  // *** handleCreateCompetencia CORREGIDO ***
  const handleCreateCompetencia = async () => { // <--- Hacerla async
    // Verificar si el usuario está autenticado
    if (!user) {
      setSnackbarMessage('Debes iniciar sesión para crear una competencia.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    // Validaciones básicas
    if (
      !newCompetencia.nombre.trim() ||
      !newCompetencia.fechaInicioCompetencia ||
      !newCompetencia.fechaFinCompetencia ||
      !newCompetencia.tipoCompetencia ||
      !newCompetencia.estado
    ) {
      setSnackbarMessage('Por favor, completa todos los campos obligatorios.');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }

    const fechaInicio = new Date(newCompetencia.fechaInicioCompetencia);
    const fechaFin = new Date(newCompetencia.fechaFinCompetencia);
    if (fechaFin < fechaInicio) {
      setSnackbarMessage('La fecha de fin no puede ser anterior a la fecha de inicio.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      return;
    }

    setLoadingCreate(true); // Iniciar loading de creación
    setIsUploading(false); // Asegurar que no esté activo al inicio
    setUploadProgress(0);

    // 1. Generar ID de competencia PRIMERO
    const newCompetenciaId = uuidv4();
    let imageUrl = null; // URL por defecto si no hay imagen

    try {
      // 2. Subir imagen SI existe
      if (newCompetencia.imagen) {
        imageUrl = await uploadImageAndGetURL(newCompetencia.imagen, newCompetenciaId);
        // Si uploadImageAndGetURL falla, lanzará un error y se capturará abajo
      }

      // 3. Preparar datos para Firestore (incluyendo URL de imagen si se subió)
      const competenciaData = {
        nombre: newCompetencia.nombre.trim(),
        fechaInicioCompetencia: newCompetencia.fechaInicioCompetencia,
        fechaFinCompetencia: newCompetencia.fechaFinCompetencia,
        tipoCompetencia: newCompetencia.tipoCompetencia,
        estado: newCompetencia.estado,
        // Convertir precio string a número antes de guardar
        precioInscripciones: parseFloat(newCompetencia.precioInscripciones) || 0,
        lugar: newCompetencia.lugar?.trim() ?? '', // Asegurar que no sea undefined
        // Añadir otros campos que se editen en el modal
        // logo: '', // El logo/imagen se manejará por separado (Firebase Storage)
        imagenPortada: imageUrl, // <-- Guarda la URL de Storage o null si no se subió
        // ...otros campos...
      };

      // Llamar a addCompetencia CON el userId
      const result = await addCompetencia(competenciaData, user.uid, newCompetenciaId);

      if (result.success) {
        setSnackbarMessage('Competencia creada exitosamente.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        handleCloseModal(); // Cerrar y resetear solo si fue exitoso
      } else {
        // Mostrar error específico de Firestore si existe
        setSnackbarMessage(`Error al crear: ${result.error?.message || 'Intente nuevamente.'}`);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    } catch (error) {
      // Capturar errores inesperados del proceso
      console.error("Error inesperado en handleCreateCompetencia:", error);
      setSnackbarMessage('Ocurrió un error inesperado.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoadingCreate(false); // Detener loading de creación
      setIsUploading(false); // Asegurar que termine indicador de subida
      setUploadProgress(0);
    }
  };

  const handleOpenModal = () => {
    // Resetear estado del modal
    setNewCompetencia({
      nombre: '',
      fechaInicioCompetencia: '',
      fechaFinCompetencia: '',
      tipoCompetencia: '',
      estado: 'pendiente',
      precioInscripciones: '',
      imagen: null,
      imagenPreview: null,
      lugar: '',
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Limpiar input file visualmente
  }
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
     // Para NumericFormat, el valor ya viene procesado
    if (name === 'precioInscripciones') {
        setNewCompetencia(prev => ({
            ...prev,
            [name]: value // Guardar el valor numérico como string
        }));
    } else {
        setNewCompetencia(prev => ({
            ...prev,
            [name]: value
        }));
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    let finalFile = null;
    //let finalFileName = null; // Guardar nombre para Storage (opcional, pero bueno)
    let previewUrl = null;

    if (newCompetencia.imagenPreview) {
        URL.revokeObjectURL(newCompetencia.imagenPreview);
    }

    if (file && file.type.startsWith('image/')) {
        setIsUploading(true);
        setSnackbarMessage('Optimizando imagen a WebP...'); // Mensaje actualizado
        setSnackbarSeverity('info');
        setSnackbarOpen(true);
        try {
            // *** LLAMAR AL NUEVO OPTIMIZADOR ***
            const optimizationResult = await optimizeAndConvertToWebP(file);

            if (optimizationResult) {
                finalFile = optimizationResult.file; // El archivo .webp
                //finalFileName = optimizationResult.suggestedFilename; // El nombre .webp
                previewUrl = URL.createObjectURL(finalFile);
                setSnackbarOpen(false);

                // Opcional: Guardar el nombre en el estado si quieres mostrarlo
                // setNewCompetencia(prev => ({ ...prev, optimizedFilename: finalFileName }));

            } else {
                setSnackbarMessage('Error al optimizar la imagen a WebP.');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                finalFile = null;
                //finalFileName = null;
                previewUrl = null;
            }
        } catch (error) {
             console.error("Error inesperado durante optimización WebP:", error);
             setSnackbarMessage('Error inesperado al procesar imagen.');
             setSnackbarSeverity('error');
             setSnackbarOpen(true);
             finalFile = null;
             //finalFileName = null;
             previewUrl = null;
        } finally {
            setIsUploading(false);
        }
    } else if (file) {
        setSnackbarMessage('Selecciona un archivo de imagen válido.');
        setSnackbarSeverity('warning');
        setSnackbarOpen(true);
        finalFile = null;
        //finalFileName = null;
        previewUrl = null;
    } else {
        finalFile = null;
        //finalFileName = null;
        previewUrl = null;
    }

    // Actualizar estado
    setNewCompetencia((prev) => ({
        ...prev,
        imagen: finalFile, // El archivo optimizado WebP (o null)
        // Opcional: guardar nombre original o sugerido si lo necesitas mostrar
        // originalImageName: file?.name ?? null,
        // webpFilename: finalFileName,
        imagenPreview: previewUrl
    }));

    if (fileInputRef.current) {
        fileInputRef.current.value = "";
    }
};

  return (
    <Box sx={{ padding: 4 }}>
      {/* Encabezado */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}
           sx={{flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 2, sm: 0 }}}>
        <Grid item xs={12} sm={6} md={6}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 500, color: 'text.primary' }}>
            Gestión de Competencias
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={6} sx={{display: 'flex',justifyContent: { xs: 'center', sm: 'flex-end' }}}>
          <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleOpenModal} sx={{ minWidth: '200px', textTransform: 'none' }}>
            Crear Competencia
          </Button>
        </Grid>
      </Box>

      {/* Lista de competencias */}
      <Grid container spacing={3}>
        {/* Mostrar loading si aplica */}
        {loadingCompetencias && (
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 5 }}>
                    <CircularProgress />
                    <Typography sx={{ ml: 2 }}>Cargando competencias...</Typography>
                </Box>
            </Grid>
        )}
        {/* Mostrar mensaje si no hay competencias y no está cargando */}
        {!loadingCompetencias && competencias.length === 0 && (
            <Grid item xs={12}>
                <Typography variant="subtitle1" align="center" color="text.secondary" sx={{mt: 4}}>
                    No has creado ninguna competencia todavía.
                </Typography>
            </Grid>
        )}
        {/* Mapear competencias y pasar el objeto completo a CompetitionCard */}
        {!loadingCompetencias && competencias.map((comp) => ( // 'comp' ES el objeto completo de la competencia
          <Grid item xs={12} sm={6} md={4} key={comp.id}>
            {/* Pasar el objeto 'comp' entero como la prop 'competencia' */}
            <CompetitionCard competencia={comp} />
          </Grid>
        ))}
      </Grid>

      {/* Modal para crear competencia */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: { xs: '90%', sm: 500 }, bgcolor: 'background.paper', p: 4, boxShadow: 24, borderRadius: 2, maxHeight: '90vh', overflowY: 'auto' }}>
          <Typography variant="h6" component="h2" mb={2}> {/* Cambiado a h2 por semántica */}
            Crear Nueva Competencia
          </Typography>
          <Grid container spacing={2}>
            {/* Nombre */}
            <Grid item xs={12}> {/* Cambiado a item */}
              <TextField required fullWidth label="Nombre de la Competencia" name="nombre" value={newCompetencia.nombre} onChange={handleInputChange} />
            </Grid>
            {/* Lugar */}
            <Grid item xs={12}>
                <TextField fullWidth label="Lugar del Evento" name="lugar" value={newCompetencia.lugar} onChange={handleInputChange} />
            </Grid>
            {/* Tipo */}
            <Grid item xs={12}>
              <TextField required fullWidth select label="Tipo de Competencia" name="tipoCompetencia" value={newCompetencia.tipoCompetencia} onChange={handleInputChange}>
                <MenuItem value="ruta">Ruta</MenuItem>
                <MenuItem value="pista_y_campo">Pista y Campo</MenuItem>
                <MenuItem value="campo_traviesa">Campo Traviesa</MenuItem>
                <MenuItem value="otros">Otros</MenuItem>
              </TextField>
            </Grid>
            {/* Fecha Inicio */}
            <Grid item xs={12} sm={6}>
              <TextField required fullWidth label="Fecha Inicio Competencia" name="fechaInicioCompetencia" type="date" InputLabelProps={{ shrink: true }} value={newCompetencia.fechaInicioCompetencia} onChange={handleInputChange} />
            </Grid>
            {/* Fecha Fin */}
            <Grid item xs={12} sm={6}>
              <TextField required fullWidth label="Fecha Fin Competencia" name="fechaFinCompetencia" type="date" InputLabelProps={{ shrink: true }} value={newCompetencia.fechaFinCompetencia} onChange={handleInputChange} />
            </Grid>
            {/* Estado */}
             <Grid item xs={12} sm={6}>
              <TextField required fullWidth select label="Estado" name="estado" value={newCompetencia.estado} onChange={handleInputChange}>
                <MenuItem value="publicado">Publicado</MenuItem>
                <MenuItem value="pendiente">Pendiente</MenuItem>
                {/* Añadir más estados si es necesario */}
              </TextField>
            </Grid>
            {/* Precio */}
            <Grid item xs={12} sm={6}>
               <TextField
                  label="Precio Inscripciones"
                  name="precioInscripciones"
                  fullWidth
                  value={newCompetencia.precioInscripciones}
                  onChange={handleInputChange} // NumericFormat se encarga de llamar a esto
                  placeholder="$0.00" // Placeholder en lugar de valor forzado
                  InputProps={{
                    inputComponent: NumericFormatCustom,
                    inputProps: {
                      'data-testid': 'precio-input' // Para testing si es necesario
                    }
                  }}
                  InputLabelProps={{ shrink: true }} // Para que el label no interfiera con el prefijo $
               />
               {parseFloat(newCompetencia.precioInscripciones) === 0 && (
                   <Chip label="Gratis" color="success" size="small"       
                   sx={{ 
                    mt: 1,
                    fontSize: '0.75rem',
                    height: '24px'
                  }}  />
               )}
            </Grid>

            {/* Imagen */}
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
              <Button variant="outlined" component="label" startIcon={<PhotoCamera />} disabled={isUploading || loadingCreate}>
                  Imagen Portada
                  <input
                    ref={fileInputRef} // Añadir ref
                    type="file"
                    accept="image/png, image/jpeg, image/webp" // Ser más específico
                    hidden
                    onChange={handleImageUpload}
                    disabled={isUploading || loadingCreate} // Deshabilitar durante subida/guardado
                  />
                </Button>
                {isUploading && (
                    <Box sx={{ width: '100%', mt: 2 }}>
                        <Typography variant="caption" display="block" gutterBottom>
                            Subiendo imagen: {Math.round(uploadProgress)}%
                        </Typography>
                        <LinearProgress variant="determinate" value={uploadProgress} />
                    </Box>
                )}
                {newCompetencia.imagenPreview && (
                  <Box sx={{ width: 100, height: 100, border: '1px solid #ccc', borderRadius: 1, overflow: 'hidden' }}>
                    <img src={newCompetencia.imagenPreview} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>

          {/* Botones del Modal */}
          <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
            <Button onClick={handleCloseModal} color="secondary">Cancelar</Button>
            <Button variant="contained" color="primary" onClick={handleCreateCompetencia} disabled={loadingCreate}>
              {loadingCreate ? <CircularProgress size={24} /> : 'Guardar'}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Snackbar */}
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default GestionInicio;